<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <defaults> </defaults>
  </div>
</template>

<script>
import Vue from "vue";
import defaults from "@/layouts/defaults.vue";

export default {
  name: "App",
  components: {
    defaults,
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  mounted() {
    //console.log('path ' +  window.location.pathname);
    if (window.location.pathname != "/exp/expDetails") {
      this.chatWindow();
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    //IM
    chatWindow() {
      var imtoken = $.cookie("IMEn-TOKEN");
      var script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("id", "imimport");
      script.setAttribute(
        "src",
        Vue.prototype.$apiIMEn +
          "Content/ChatIM/js/imimport.js?verson=" +
          Math.random() +
          "&entId=1&token=" +
          imtoken +
          "&lan=English"
      );
      document.getElementsByTagName("head")[0].appendChild(script);
    },
  },
};
</script>

<style ype="text/css" rel="stylesheet" scoped="scoped">
#app {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue